import { useForm } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Dialog,
  Button,
  Backdrop,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { TextWithCount } from 'components/Fields';

function ModalTitle(props) {
  const {
    createVideo,
    CRUD_STATES,
    auth,
    setAuth,
    createCollection,
    setNotify,
    type,
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState('');
  const navigate = useNavigate();
  const { handleSubmit, reset, control, getValues, setValue } = useForm();
  const location = useLocation();
  const isCollectionsNewPath = location.pathname === '/colecoes-novo';
  const collectionWizardPath = isCollectionsNewPath
    ? '/colecao-novo'
    : '/series';

  function closeModal() {
    reset();
    props.onClose();
  }

  const onSubmit = async data => {
    const formValues = getValues();
    if (formValues?.title) {
      setIsLoading(true);
      if (location.pathname === '/videos' || type === 'video') {
        let res = await createVideo(auth, setAuth, formValues.title);
        setIsLoading(false);
        closeModal();

        location.pathname === '/videos' &&
          navigate(`/upload-video/${res?.id}/${res.version}`, {
            state: { action: CRUD_STATES.CREATE },
          });

        type === 'video' &&
          window.open(
            `/upload-video/${res?.id}/${res.version}/CREATE`,
            '_blank'
          );
      } else if (
        location.pathname === '/series' ||
        location.pathname === '/colecoes-novo' ||
        type === 'collection'
      ) {
        let res = await createCollection(
          auth,
          setAuth,
          setNotify,
          formValues.title
        );
        setIsLoading(false);
        closeModal();

        (location.pathname === '/series' ||
          location.pathname === '/colecoes-novo') &&
          navigate(`${collectionWizardPath}/${res?.id}/${res.version}`, {
            state: { action: CRUD_STATES.CREATE },
          });

        type === 'collection' &&
          window.open(
            `${collectionWizardPath}/${res?.id}/${res.version}/CREATE`,
            '_blank'
          );
      }

      // navigate(`/upload-video/${action?.id}`, { state: { action: action.action } });
      // alert('Funcionalidade ainda em desenvolvimento. Em breve estará disponível!')
    }
  };

  return (
    <>
      <Dialog open={props.open} onClose={closeModal}>
        <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Form onSubmit={handleSubmit(onSubmit)} style={{ width: 480 }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              padding: 12,
              paddingTop: 22,
              position: 'relative',
            }}>
            <div style={{ position: 'absolute', top: '15px', left: '15px' }}>
              <svg
                style={{ marginRight: 7 }}
                width="46"
                height="46"
                viewBox="0 0 39 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.3">
                  <rect
                    x="6.50391"
                    y="6.41211"
                    width="26"
                    height="26"
                    rx="5"
                    stroke="rgb(19, 97, 164)"
                    strokeWidth="2"
                  />
                </g>
                <g opacity="0.1">
                  <rect
                    x="1.50391"
                    y="1.41211"
                    width="36"
                    height="36"
                    rx="7"
                    stroke="rgb(19, 97, 164)"
                    strokeWidth="2"
                  />
                </g>
                <path
                  d="M19.5033 22.7453V19.4119M19.5033 16.0786H19.5116M27.8366 19.4119C27.8366 24.0143 24.1056 27.7453 19.5033 27.7453C14.9009 27.7453 11.1699 24.0143 11.1699 19.4119C11.1699 14.8096 14.9009 11.0786 19.5033 11.0786C24.1056 11.0786 27.8366 14.8096 27.8366 19.4119Z"
                  stroke="rgb(19, 97, 164)"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <DialogTitle
              style={{
                lineHeight: 0,
                color: 'rgba(16, 24, 40, 1)',
                textAlign: 'center',
                width: '100%',
              }}>
              <strong>Insira o título</strong>
            </DialogTitle>
          </div>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme => theme.palette.grey[500],
            }}>
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <TextWithCount
              name="title"
              label="Título"
              placeholder="Digite o título"
              maxLength={72}
              control={control}
              defaultValue={title}
            />
          </DialogContent>
          <DialogActions
            style={{ padding: '0 24px 24px', justifyContent: 'space-around' }}>
            <Button
              style={{
                marginLeft: 12,
                color: 'rgba(19, 97, 164, 1)',
                borderRadius: 8,
                background: 'rgba(255, 255, 255, 1)',
                borderColor: 'rgba(19, 97, 164, 1)',
                padding: '10px 18px',
                width: '140px',
              }}
              variant="contained"
              onClick={() => {
                setTitle('');
                setValue('title', '');
                closeModal();
              }}>
              Cancelar
            </Button>
            <Button
              style={{
                color: 'rgba(255, 255, 255, 1)',
                borderRadius: 8,
                width: '140px',
                marginLeft: 12,
                background: 'rgba(19, 97, 164, 1)',
                borderColor: 'rgba(19, 97, 164, 1)',
                padding: '10px 18px',
              }}
              variant="contained"
              type="submit">
              Avançar
            </Button>
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
}

export default ModalTitle;
